export const navLinks = [
  {
    label: 'Projects',
    pathname: '/',
    hash: '#project-1',
  },
  {
    label: 'Details',
    pathname: '/',
    hash: '#details',
  },
  // {
  //   label: 'Articles',
  //   pathname: '/articles',
  // },
  {
    label: 'Contact',
    pathname: '/contact',
  },
];

export const socialLinks = [
  /*   {
    label: 'Linkedin',
    url: 'www.linkedin.com/in/xavierww',
    icon: 'linkedin',
  }, */
  /*   {
    label: 'Figma',
    url: 'https://www.figma.com/X',
    icon: 'figma',
  }, */
  {
    label: 'Github',
    url: 'https://github.com/Xavier-WW',
    icon: 'github',
  },
];
